import script from './ChartingItemGroup.vue2.js';
import normalizeComponent from '../../../../node_modules/vue-runtime-helpers/dist/normalize-component.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.item
    ? _c(
        "div",
        { staticClass: "ChartingItemGroup" },
        [
          _vm.isGroup && _vm.item.children
            ? _c(
                "CardWithHeaderLight",
                {
                  staticClass: "mb-17",
                  attrs: {
                    boxShadow: "",
                    headerTitle: _vm.item.title,
                    withBottomSpacing: false
                  }
                },
                [
                  _vm._l(_vm.item.children, function(it, index) {
                    return [
                      !it.id ||
                      _vm.conditionalFollowUpDisplayMap[it.id] === undefined ||
                      _vm.conditionalFollowUpDisplayMap[it.id]
                        ? _c("ChartingItemCard", {
                            key: "group" + it.productID + "-" + index,
                            attrs: {
                              procedureID: _vm.procedureID,
                              indexArray: _vm.indexArray.concat([index])
                            }
                          })
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            : _c(
                "BasicCard",
                {
                  staticClass: "mb-17",
                  attrs: {
                    cardStyle: "white-with-border",
                    alignLeft: "",
                    boxShadow: ""
                  }
                },
                [
                  _c("ChartingItemCard", {
                    attrs: {
                      indexArray: _vm.indexArray,
                      procedureID: _vm.procedureID
                    }
                  })
                ],
                1
              )
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "ChartingItemGroup ph-24" },
        [
          _c(
            "BasicCard",
            { staticClass: "mb-4 mt-18", attrs: { cardStyle: "danger" } },
            [
              _vm._v(
                "\n    There was a problem loading charting information.\n  "
              )
            ]
          )
        ],
        1
      )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as default };
